import { Injectable } from '@angular/core';
import { OfbizField } from './../ofbiz-form-model';
import { BehaviorSubject } from 'rxjs';
import { OfbizCellDisplayLinkComponent } from './../ofbiz-cell-display-link/ofbiz-cell-display-link.component';
import { OfbizCellDisplayComponent } from './../ofbiz-cell-display/ofbiz-cell-display.component';
import { OfbizCellHyperLinkComponent } from './../ofbiz-cell-hyper-link/ofbiz-cell-hyper-link.component';
import { RemoteFormData } from './../ofbiz-form-model';
import { SmartTableDatePickerComponent } from './../smart-table-date-picker/smart-table-date-picker.component'
import { OfbizCustomLinkEditorComponent } from './../ofbiz-custom-link-editor/ofbiz-custom-link-editor.component';
import { OfbizCellLinkedListComponent } from './../ofbiz-cell-linked-list/ofbiz-cell-linked-list.component';
import { OfbizCellInternalLinkComponent } from './../ofbiz-cell-internal-link/ofbiz-cell-internal-link.component';
import { OfbizCellDropdownComponent } from './../ofbiz-cell-dropdown/ofbiz-cell-dropdown.component';
import { OfbizCellDropdownEditorComponent } from './../ofbiz-cell-dropdown-editor/ofbiz-cell-dropdown-editor.component';
import { Observable } from 'rxjs';
import { OfbizCellCheckComponent } from './../ofbiz-cell-check/ofbiz-cell-check.component';
import { OfbizCheckBoxEditorComponent } from './../ofbiz-check-box-editor/ofbiz-check-box-editor.component';
import { ColumnConfigService } from './column-config.service';

@Injectable({
  providedIn: 'root'
})
export class OfbizListService {
  allColumns = new BehaviorSubject(true);
  hyperlinkCellSelected = new BehaviorSubject<any>(null);
  dropDownOptions = new BehaviorSubject<any[]>([]);

  constructor(private columnConfigService:ColumnConfigService) { }

  setAllColumnsState(state: boolean): any {
    //console.log("setting columnstate:"+state)
    this.allColumns.next(state);
  }

  getAllColumnsState() {
    return this.allColumns.asObservable()
  }

  createColumns(fields:any[],findFields:any[],listOptions:any,isLookup:boolean,isMulti:boolean):any{
    console.log({TrackColumnFields:fields,ListOptions:listOptions});
    let columns = {};
    let hiddedFields = ["submit","hidden","SUBMIT","HIDDEN",undefined]

    fields.forEach(field => {
      if(!hiddedFields.includes(field.type)){
        //ensure that field has title
        /* if(field.title == undefined || field.title == ""){
          if(this.columnF)
        } */
       // columns[field.name] = this.configureColumn(field,findFields,listOptions)
        columns[field.name] = this.columnConfigService.createColumn(field,findFields,listOptions)
        console.log(columns[field.name]);
        
      }
    });
    if(isMulti){
      columns["checkbox"] = this.configureCheckBoxColumn();
    }
    //console.log({TrackColumn:columns});
    return columns;
  }

  configureCheckBoxColumn():any{
    let column = {};
    column["title"]="Selected";
    column["type"] = "custom";
    column["editable"] = false;
    column["editor"] = {"type":"custom","component":OfbizCheckBoxEditorComponent};
    column["renderComponent"] = OfbizCellCheckComponent;
    column["valuePrepareFunction"] = (cell,row) => {
      console.log({Cell:cell,Row:row});
    }
    column["onComponentInitFunction"] = (instance) => {
      instance.setValue(instance);
    };
    return column
  }
  /**
   * @comment Lookup columns are used with lookup fields.  Selected value is returned to populate the lookup field
   * @param field for which the column is being configured
   * @param findFields 
   * @param listOptions
   * @returns the column object 
   */
  configureLookupColumn(field:OfbizField,findFields:any[],listOptions:any):any{

  }
  /**
   * Function used to define each column in the table
   * @param field 
   * @returns the column object
   */
  /* configureColumn(field:OfbizField,findFields:any[],listOptions:any):any{
    let labelColumn = listOptions.labelColumn ? listOptions.labelColumn : undefined;
    let column = {};
    let type = this.columnConfigService.getType(field);
    column["title"] = field.title;
    column["type"] = type;
    if(field.description){
      column["valuePrepareFunction"] = (value) => {
        return field.description;
      } 
    }
    if(field.entryName){
      column["valuePrepareFunction"] = (cell,row) => {
        let entryName = field.entryName;
        return row[entryName];
      }
    }
    if(type == "custom"){
      console.log(field);
      let columnComponent = this.columnConfigService.getRenderComponent(field);
      column["renderComponent"] = columnComponent;
      if(field.type == "hyperlink" || field.type == "HYPERLINK"){
        column["onComponentInitFunction"] = (instance) => {
          instance.remoteFormData = "kak"
          instance.cellHyperlinkSelected.subscribe(data =>
            {
              this.columnConfigService.setHyperlinkCell({field:field,rowData:data,labelColumn:labelColumn})
            })
        };
      }
      if(field.type == "display-entity" || field.type == "DISPLAY_ENTITY"){
        if(field.parameterList || field.hyperlink){
          column["onComponentInitFunction"] = (instance) => {
            instance.cellHyperlinkSelected.subscribe(data =>
              {
                this.columnConfigService.setHyperlinkCell({field:field,rowData:data,labelColumn:labelColumn})
              })
          };
        }else{
          column["valuePrepareFunction"] = (value) => {
            return this.getDisplayValue(value,field,findFields);
          }
        }
        
      }
      if(field.type == "DROP_DOWN" || field.type == "drop-down"){
        column["valuePrepareFunction"] = (value) => {
          let fieldOptions:any[] = field["options"];
          let currentOption = fieldOptions.find(option => option["key"] == value);
          if(currentOption){
            return currentOption["description"]
          }else{
            return value
          }
        }
      }
    }
    column["editable"] = this.columnConfigService.getEditable(field);
    column["editor"] = this.columnConfigService.getEditor(field);
    column["filter"] = false;
    column["sort"] = true;
    return column
  } */
  /* getEditor(field):any{
    let editor = {};
    switch (field["type"]) {
      case "datetime":
      case "DATE_TIME":
        editor = {"type":"custom","component":SmartTableDatePickerComponent}
        break;
      case "hyperlink":
      case "HYPERLINK":
        editor = {"type":"custom","component":OfbizCustomLinkEditorComponent}
        break;
      case "DROP_DOWN":
        editor = {"type":"custom","component":OfbizCellDropdownEditorComponent}
        break;
      default:
        editor = {"type":"text"}
        break;
    }
    return editor;
  } */
  /**
   * 
   * @param field The field for which the type is to be returned
   * @returns html,custom, text(default)
   */
  /* getType(field):string{
    let type = "";
    switch (field["type"]) {
      case "datetime":
      case "DATE_TIME":
        type="html"  
        break;
      case "hyperlink":
      case "HYPERLINK":
      case "drop-down":
      case "DROP_DOWN":
        type="custom"  
        break;
      case undefined:
        type="text"  
        break;
      case "display-entity":
      case "DISPLAY_ENTITY":
        type="custom"  
        break;
      default:
        type="text"
        break;
    }
    return type
  } */
  /**
   * Function used to set the editable property of a column
   * @param field 
   * @returns boolean - true, field is editable. false, field is not editable
   */
  /* getEditable(field:OfbizField):boolean{
    let editable = false;
    if(field.readonly == false){
      return editable = true
    }else{
      switch (field.type) {
        case "text":
        case "TEXT":
          editable = true        
          break;
        case "datetime":
        case "DATE_TIME":
          editable = true
          break;
        case "DROP_DOWN":
          this.createDropDownOptions(field);
          editable = true;
           break
        default:
          editable = false
          break;
      }
    }
    return editable;
  } */
  /**
   * Function to determine and set the component used for the renderComponent property of a column
   * @param field The field containing the type which is used to decide which component to return
   * @returns the component to be used to render the cell;
   */
  /* getRenderComponent(field:OfbizField):Component{
    let component = null;
    switch (field["type"]) {
      case "hyperlink":
      case "HYPERLINK":
        if(field.event != undefined && field.event == "list"){
          component = OfbizCellLinkedListComponent;
        }else{
          component = OfbizCellHyperLinkComponent
        }
        
        break;
      case "display-entity":
      case "DISPLAY_ENTITY":
        if(field.parameterList || field.hyperlink){
          console.log({TrackRenderComponent:{Component:"OfbizListServices",field:field}})
          if(field.hyperlink && field.hyperlink.targetType != undefined){
            component = OfbizCellInternalLinkComponent;
          }else{
            component = OfbizCellDisplayLinkComponent
          }
        }else{
          component = OfbizCellDisplayComponent
        }
        break;
      case "drop-down":
      case "DROP_DOWN":
        console.log("Setting OfbizCellDropdownComponent")
        component = OfbizCellDropdownComponent
        break;
      default:
        break;
    }
    return component
  } */ 
  /**
   * Function used to set values for the  cell hyperlink
   * Values emitted are event,type, data(formData and endPoint)
   * @param data - field and row data
   */
  /* setHyperlinkCell(data: any): void {
    let rowData = data["rowData"];
    let field = data["field"];
    let labelColumn = data.labelColumn != undefined ? data.labelColumn : field.name;
    let hyperLink:any = {};
    if(field.type == "hyperlink" || field.type == "HYPERLINK"){
      console.log({HyperLink:field});
      hyperLink = {"target":field["target"],"event":field["event"],"parameters":{},"formData":field["formData"],"appContext":field["appContext"]};
      console.log({HyperLinkAfter:hyperLink});
    }else if(field.type == "display-entity" || field.type == "DISPLAY_ENTITY"){
      if(field.hyperlink){
        hyperLink = {
          "targetType":field.hyperlink["targetType"],
          "target":field.hyperlink["target"],
          "name":field.name,
          "rowData":rowData,
          "event":"link",
          "remoteFormData":field.hyperlink["remoteFormData"],
        }
      }else{
        hyperLink = {"target":field["entityName"],"event":field["event"],"parameters":{},"formData":field["formData"]};
      }
      
    }
 
    if(rowData["parameterMaps"] != undefined && rowData["parameterMaps"].length > 0){
      let parameterMaps:any [] = rowData["parameterMaps"];
      let parameterMap = parameterMaps.find(element => element.fieldName == field.name);
      if(parameterMap != undefined){
        hyperLink.parameters = parameterMap["parameterMap"];
      }else{
        parameterMap = parameterMaps[0];
        hyperLink.parameters = parameterMap["parameterMap"];
      }
    }else{
      let parameterList:any[] = field["parameterList"];
      parameterList.forEach(parameterData => {
        let parameter = {};
        if(data["field"].type == "hyperlink" || data["field"].type == "HYPERLINK"){
          if(rowData[parameterData["fromField"]["original"]]){
            parameter[parameterData["name"]] = rowData[parameterData["fromField"]["original"]];
          }
        }else if(field.type == "display-entity" || field.type == "DISPLAY_ENTITY"){
          parameter[parameterData["name"]] = rowData[parameterData["name"]];
        }
        Object.assign(hyperLink.parameters,parameter);
      })
    }
    console.log({hyperLinkAfterParameters:hyperLink});
    if(hyperLink.formData.link && hyperLink.parameters){
      if(this.containsDollarBracketVariable(hyperLink.formData.link)){
        hyperLink.formData.link = this.replaceDollarBracketVariable(hyperLink.formData.link,hyperLink.parameters);
      }
    }
    
    let event = hyperLink["event"];
    let remoteFormData = {};
    if(event != "link"){
      let remoteFormDataHolder:RemoteFormData = {
        formData:{
          "formName":hyperLink["formData"].formName,
          "formLocation":hyperLink["formData"].formLocation,
          "listType":hyperLink["formData"].listType || "form",
          "link":hyperLink["formData"].link || null,
        },
        endPoint:hyperLink["formData"].endPoint,
        parameters:hyperLink.parameters,
        "appContext":hyperLink["appContext"] || "",
      }
      remoteFormData = remoteFormDataHolder;
    }
    
    let returnValue = {};
    switch (event) {
      case "view":
        returnValue = {"event":"view","type":hyperLink["formData"]["formName"],"data":remoteFormData,"label":rowData[labelColumn]};
        this.hyperlinkCellSelected.next(returnValue);
        break;
      case "list":
        returnValue = {"event":"list","type":hyperLink["formData"]["formName"],"data":remoteFormData,"label":rowData[labelColumn]};
        this.hyperlinkCellSelected.next(returnValue);
        break;
      case "edit":
        returnValue = {"event":"edit","type":hyperLink["formData"]["formName"],"data":remoteFormData,"label":rowData[labelColumn]};
        this.hyperlinkCellSelected.next(returnValue);
        break;
      case "delete":
        returnValue = {"event":"delete","type":hyperLink["formData"]["formName"],"data":remoteFormData,"label":rowData[labelColumn]}
        this.hyperlinkCellSelected.next(returnValue);
        break;
      case "add":
        returnValue = {"event":"add","type":hyperLink["formData"]["formName"],"data":remoteFormData,"label":rowData[labelColumn]}
        this.hyperlinkCellSelected.next(returnValue);
        break;
      case "link":
        returnValue = hyperLink;
        this.hyperlinkCellSelected.next(returnValue);
        break;
      default:
        break;
    }
    
  } */

  getHyperlinkCell() {
    //return this.hyperlinkCellSelected.asObservable()
    return this.columnConfigService.hyperlinkCellSelected.asObservable();
  }
  /**
   * Function to transform the original cell value into a display value
   * @param value The original value of the cell to be transformed
   * @param field The field containing the name to be used in the lookup
   * @param findFields List of fields from a FindForm containing the description to be displayed in place of the original value
   * @returns The displayValue
   */
  getDisplayValue(value:string,field:OfbizField,findFields:any[]):string{
     let description = null;
    if(findFields != undefined){
      let findField = findFields.find(element => element.name == field.name);
      if(findField){
        if(findField.allOptionValues){
          let findValue = findField.allOptionValues.find(element => element.key == value);
          if(findValue){
            description = findValue.description;
          }
        }
      }
    }
    if(description == null && value != null){
      description = value;
    }
    //console.log({"GettingDisplayValue":description,field:field.name});
    return description;
  }

  parametersToFormData(parameters:any):FormData{
    let formData = new FormData();
    Object.entries(parameters).forEach(([key, value]) => {
      formData.append(key,parameters[key]);
    });
    return formData
  }

  createDropDownOptions(field):void{
    //console.log({TrackDropDown:"Setting Stuff"})
    let fieldOptions = {name:field.name,options:field.options}
    this.dropDownOptions.next(this.dropDownOptions.getValue().concat([fieldOptions]));
  }

  getDropdownOptions():Observable<any[]>{
    //console.log({TrackDropDown:"Getting Options"})
    return this.dropDownOptions.asObservable();
  }

  containsDollarBracketVariable(str: string): boolean {
    const regex = /\${(.*?)}/;
    return regex.test(str);
  }

  replaceDollarBracketVariable(str: string, variables: { [key: string]: string }): string {
    return str.replace(/\${(.*?)}/g, (match, p1) => {
        return variables[p1] || '';
    });
  }

}
